module.exports = __webpack_public_path__ + "static/og-cca019b975290e01325dc545a2d097a1.png";